import IdeationVotePickerVM from 'components/ideationVotePicker/ideationVotePicker';
import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import { EffectsContainer } from 'mixins/withEffects';
import { JSONTopicThread } from 'models/topicThread';
import WCCError from 'models/wccError';
import { ServicesContext } from 'services/context';
import TextThreadEditorVM, { TextThreadEditorVMConfig } from '../textThread';
import './ideationVote.scss';

components.preload('ideation-vote-picker');

export interface IdeationVoteEditorVMConfig extends TextThreadEditorVMConfig {
    votesPickerContainer: SubscribableOrNullableValue<HTMLElement>
}

@injectable()
export default class IdeationVoteEditorVM extends TextThreadEditorVM {
    mediaSize = 75

    votePicker = ko.observable<IdeationVotePickerVM>();
    vote = this.votePicker.pluck(p => p.pickedVote);

    initialVote: Subscribable<number | undefined>
    isActive: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: IdeationVoteEditorVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager,
        @inject(wccModules.servicesContext) ctx: ServicesContext,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        super(config, info, storage, ctx, effects);

        this.initialVote = this.thread.pluck(th => th.vote);
        this.isActive = this.vote.isNotNull();

        effects.register((isActive, textEditor) => {
            if (isActive && textEditor != undefined)
                textEditor.focus();
        }, [this.isActive, this.textEditor]);

        effects.register((container) => {
            if (container != undefined) {
                const pickerNode = $(`<ideation-vote-picker params="model: { topicId: topicId, initialVote: initialVote }, ref: votePicker"></comment-ideation-vote-picker>`)[0];

                ko.applyBindings(this, pickerNode);
                container.appendChild(pickerNode);

                return () => ko.removeNode(pickerNode);
            }
        }, [config.votesPickerContainer]);

        ko.applyBindingsToNode(info.element, {
            'visible': this.isActive,

            'css': {
                'ideation-vote-editor': true
            }
        }, this);
    }

    protected override checkIfAllowedToCancel() {
        return super.checkIfAllowedToCancel() || this.isActive();
    }

    protected override checkIfTextIsMandatory() {
        return true;
    }

    protected override async saveThread(jsonThread: JSONTopicThread): Promise<void> {
        const vote = this.vote();

        if (vote == undefined)
            throw new WCCError(messages.UnknownError);

        await this.ctx.commentsService.vote(jsonThread, vote);
    }

    protected override async updateThread(jsonThread: JSONTopicThread): Promise<void> {
        const vote = this.vote();

        if (vote == undefined)
            throw new WCCError(messages.UnknownError);

        await this.ctx.commentsService.updateVote(jsonThread, vote);
    }

    protected override reset() {
        super.reset();

        this.votePicker()?.reset();
    }
}